import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Marker, Polyline, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L, { Path } from 'leaflet';
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";
// import TextPolyline from "../modules/TextPolyline";
import '../../styles/Pillars04.css'
import { selectTasksPoints } from "../../store/selectors/tasksSelector";
import { fetchPointsTasks } from "../../store/reducers/tasksReducer";
import { 
    taskNotStartedIconString, 
    taskInProgressIconString, 
    taskDeferredIconString, 
    taskCompletedIconString, 
    taskCancelledIconString, 
    taskRejectedIconString
} from "./icons";
import { selectElectricityFiltered, selectlectricityFilteredSet, selectMappedElectricityFiltered } from "../../store/selectors/supervisionSelector";


// Функция для получения иконки статуса задачи в формате строки
function getTaskStatusIconString(status, size = 24) {
    switch (status) {
        case 'new':
            return taskNotStartedIconString(size);
        case 'progress':
            return taskInProgressIconString(size);
        case 'paused':
            return taskDeferredIconString(size);
        case 'done':
            return taskCompletedIconString(size);
        case 'cancelled':
            return taskCancelledIconString(size);
        case 'review':
            return taskRejectedIconString(size);
        default:
            return null;
    }
}

// Создаем иконку для границ задач
const createBorderIcon = () => {
    return L.divIcon({
        html: ``,
        iconSize: [14, 14],
        iconAnchor: [7, 7],
        className: 'task-border-icon'
    });
};

// Создаем иконку маркера с иконкой статуса задачи
const createTaskStatusMarkerIcon = (status) => {
    const iconSize = 32;
    const statusIconString = getTaskStatusIconString(status, iconSize);
    
    if (!statusIconString) {
        // Если иконка статуса не найдена, возвращаем пустую иконку
        return L.divIcon({
            html: ``,
            iconSize: [0, 0],
            iconAnchor: [0, 0],
            className: 'task-point-icon'
        });
    }
    
    const iconHtml = `
        <div style="display: flex; align-items: center; justify-content: center; width: ${iconSize}px; height: ${iconSize}px; filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));">
            ${statusIconString}
        </div>
    `;
    
    return L.divIcon({
        html: iconHtml,
        iconSize: [iconSize, iconSize],
        iconAnchor: [iconSize / 2, iconSize + 5],
        // tooltipAnchor: [iconSize / 2, iconSize / 2],
        className: 'task-status-marker-icon'
    });
};

// Форматирование даты с временем в формате HH:MM dd.mm.yyyy
const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';
        // Получаем локальную дату и время в формате ISO
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes} ${day}.${month}.${year}`;
    } catch {
        return '';
    }
};


export const LayerTasks = props => {
    console.log(props)
    const map = useMap();
    const dispatch = useDispatch();
    const [mapState, setMapState] = useState({ zoom: map.getZoom(), bounds: map.getBounds() });
    const [keyForRender, setKeyForRender] = useState(0)
    // const [showFiders, setShowFiders] = useState(JSON.parse(localStorage.getItem('kanban_settings') || '{}')?.showFiders || false);
    const usersSettings = useSelector(state => state.state.usersSettings)
    const drawing = useSelector(state => state.state.drawing)
    const [expandedTooltips, setExpandedTooltips] = useState({})

    // const electricitySets = useSelector(selectlectricityFilteredSet)
    const electricityMaps = useSelector(selectMappedElectricityFiltered)


    // Динамическое создание CSS стилей для каждого пользователя
    useEffect(() => {
        if (!usersSettings) return;
        // Создаем или обновляем style элемент
        let styleElement = document.getElementById('dynamic-tasks-tooltips');
        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = 'dynamic-tasks-tooltips';
            document.head.appendChild(styleElement);
        }

        // Генерируем CSS для каждого пользователя
        const cssRules = usersSettings.map(user => {
            const settings = user.settings || {};
            return `
                .tooltip-tasks-user-${user.id} {
                    background-color: ${settings.line_color || 'rgba(197, 197, 197, 0.7)'} !important;
                    color: ${settings.text_color || '#333'} !important;
                    border: 1px solid ${settings.line_color || '#333'} !important;
                    border-radius: 4px !important;
                    font-size: 12px !important;
                    font-weight: bold !important;
                    font-style: italic !important;
                    padding: 1px 2px !important;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3) !important;
                    
                    // min-width: 120px !important;
                    // text-align: center !important;
                    // position: relative !important;
                }
                
                

                
                /* Стрелка на конце линии - указывает на объект */
                .tooltip-tasks-user-${user.id}::before {
                    content: '' !important;
                    position: absolute !important;
                    left: -3px !important;  
                    top: 16px !important;
                    width: 0 !important;
                    height: 0 !important;
                    border-top: 5px solid transparent !important;
                    border-bottom: 5px solid transparent !important;
                    border-right: 8px solid ${settings.line_color || '#000000'} !important;
                    transform-origin: center !important;
                    transform: translateY(-50%)  !important;
                    z-index: 1001 !important;
                }
            `;
        }).join('\n');

        // /* Создаем соединительную линию от tooltip к объекту */
        // .tooltip-user-${user.id}::after {
        //     content: '' !important;
        //     position: absolute !important;
        //     left: -30px !important;
        //     top: 100% !important;
        //     width: 30px !important;
        //     height: 2px !important;
        //     background-color: ${settings.line_color || '#000000'} !important;
        //     transform-origin: top right !important;
        //     transform: translateY(-50%) rotate(-45deg) !important;
        //     z-index: 1000 !important;
        // }


        

        styleElement.innerHTML = cssRules;

        // Очистка при размонтировании
        return () => {
            const element = document.getElementById('dynamic-tasks-tooltips');
            if (element) {
                element.remove();
            }
        };
    }, [usersSettings]);
    // console.log(JSON.parse(localStorage.getItem('kanban_settings') || '{}')?.showFiders)
    // Подписываемся на события карты для обновления при перемещении/зуме
    useEffect(() => {
        const handleMapChange = () => {
            setMapState({ zoom: map.getZoom(), bounds: map.getBounds() });
        };

        map.on('zoomend', handleMapChange);
        map.on('moveend', handleMapChange);
        // map.on('phantom:show', () => setShowFiders(true));
        // map.on('phantom:hide', () => setShowFiders(false));
        return () => {
            map.off('zoomend', handleMapChange);
            map.off('moveend', handleMapChange);
            // map.off('phantom:show', () => setShowFiders(true));
            // map.off('phantom:hide', () => setShowFiders(false));
        };


    }, [map]);

    // Загрузка данных points tasks каждую минуту
    useEffect(() => {
        // Загружаем сразу при монтировании
        dispatch(fetchPointsTasks(props.statuses));

        // Устанавливаем интервал для обновления каждую минуту
        const interval = setInterval(() => {
            dispatch(fetchPointsTasks(props.statuses));
        }, 60000); // 60000 мс = 1 минута

        return () => {
            clearInterval(interval);
        };
    }, [dispatch, props.statuses]);

    // Слушаем событие обновления задач
    useEffect(() => {
        const handleTasksRefresh = () => {
            dispatch(fetchPointsTasks(props.statuses));
        };

        map.on('tasks:refresh', handleTasksRefresh);

        return () => {
            map.off('tasks:refresh', handleTasksRefresh);
        };
    }, [map, dispatch, props.statuses]);


    const pointsTasks = useSelector((state) => state.tasks.pointsTasks);




    useEffect(() => {
        setKeyForRender(prev => prev + 1)
    }, [pointsTasks])

    const handleMarkerClick = useCallback((task) => (e) => {
        // Проверяем, не был ли клик по tooltip
        const target = e.originalEvent?.target || e.nativeEvent?.target;
        if (target && (target.closest('.leaflet-tooltip') || target.classList.contains('leaflet-tooltip'))) {
            return;
        }
        
        map.fire('openPopup', {
            class: task.baseType,
            mark: electricityMaps[task.baseType].get(task.fid),
        });
    }, [map, drawing, electricityMaps]);

   

    // Создаем маркеры для points tasks
    const pointsMarkers = useMemo(() => {
        if (!pointsTasks || typeof pointsTasks !== 'object') return [];

        const allMarkers = [];
        const taskTypes = Object.keys(pointsTasks)

        taskTypes.forEach(type => {
            const tasks = pointsTasks[type] || [];
            if (!Array.isArray(tasks)) return;
            
            tasks.forEach((task, index) => {
                if (!task || !task.coords || !Array.isArray(task.coords) || task.coords.length < 2) return;
                if (!electricityMaps[task.baseType].has(task.fid || task.id)) return
                if (!props.statuses.includes(task.status)) return
                // Проверяем, что координаты валидны
                const lat = task.coords[0];
                const lng = task.coords[1];
                if (typeof lat !== 'number' || typeof lng !== 'number' || isNaN(lat) || isNaN(lng)) return;

                const responsibleName = usersSettings?.find(us => us.id === task.responsible)?.name || (task.responsible ? `id${task.responsible}` : 'Не назначен');
                const deadlineText = formatDate(task.deadline);
                const title = task.title || 'Без названия';
                const tooltipText = `${title} | ${deadlineText} | ${responsibleName}`;
                const taskId = `${task.id || task.fid || index}_${type}`;
                const isExpanded = expandedTooltips[taskId] || false;

                allMarkers.push(
                    <Marker
                        position={[lat, lng]}
                        key={`tasks_${type}_${task.fid || task.id || index}_${type.includes('fider') ? `${task.segment}_` : ''}${keyForRender}`}
                        icon={createTaskStatusMarkerIcon(task.status)}
                        pane="tasksPane"
                        interactive={!drawing}

                        eventHandlers={{
                            click: handleMarkerClick(task)
                        }}
                    >
                        <Tooltip
                            key={`tasks_${task.id || task.fid}_tooltip_${isExpanded ? 'full' : ''}`}
                            permanent
                            direction="right"
                            offset={[12, -25]}
                            className={`dynamic-tasks-tooltip tooltip-tasks-user-${task.responsible || 0}`}
                            interactive
                            eventHandlers={{
                                click: (e) => {
                                    if (e.originalEvent) {
                                        e.originalEvent.stopPropagation();
                                        e.originalEvent.stopImmediatePropagation();
                                    }
                                    if (e.nativeEvent) {
                                        e.nativeEvent.stopPropagation();
                                        e.nativeEvent.stopImmediatePropagation();
                                    }
                                    L.DomEvent.stopPropagation(e);
                                    setExpandedTooltips(prev => ({
                                        ...prev,
                                        [taskId]: !prev[taskId]
                                    }));
                                },
                                mouseover: (e) => {
                                    setExpandedTooltips(prev => ({
                                        ...prev,
                                        [taskId]: true
                                    }));
                                },
                                mouseout: (e) => {
                                    setExpandedTooltips(prev => ({
                                        ...prev,
                                        [taskId]: false
                                    }));
                                },
                            }}
                        >
                            {isExpanded ? tooltipText : tooltipText.slice(0, 20) + "..."}
                        </Tooltip>
                    </Marker>
                );
            });
        });

        return allMarkers;
    }, [pointsTasks, usersSettings, keyForRender, electricityMaps, expandedTooltips, drawing, handleMarkerClick]);

    return [...pointsMarkers];
};

LayerTasks.displayName = 'LayerTasks';


